import config from "../../../../config";
import { ResponseDto } from '../../../../dtos/common/responseDto';
import { deleteData, getData, patchData, postData } from '../../../../utils/axios/serverHelper';
import { formatDate } from '../../../../utils/string/stringUtil';
import axios from 'axios';
import { WMS1031_R01DetailDto, WMS1031_R01Dto, WMS1031_R01HeaderDto, WMS1031_R01LotDto } from "./Dto_WMS1031_R01";
import { WMS1031_R01Filter } from "./Store_WMS1031_R01";


const baseUrl = `${config.apiUrl}/WMS1031_R01`;

const getParams = (filter: Partial<WMS1031_R01Filter>, listLength?: number) => {	
	return {
		startDate: filter.dateRange?.from ? formatDate(filter.dateRange.from) : undefined,
		endDate: filter.dateRange?.to ? formatDate(filter.dateRange.to) : undefined,
		customCd: filter.customCd || undefined,	

		listLength: listLength || 0
	}
}

export const getWMS1031_R01List = async (option: string, params: Partial<WMS1031_R01Filter>, listLength: number = 0) => {

	const url = `${baseUrl}/${option}`;

	return await getData<ResponseDto<WMS1031_R01HeaderDto[]>>(url, { params: getParams(params, listLength) });
}

export const getWMS1031_R01AllCount = async (params: Partial<WMS1031_R01Filter>) => {
    const url = `${baseUrl}/allCount`;

    return await getData<ResponseDto<number>>(url, {
        params: getParams(params, 0)
    });
}

export const getWMS1031_R01One = async (wmsOrderNo: string) => {
	const url = `${baseUrl}/one/${wmsOrderNo}`;

	return await getData<ResponseDto<WMS1031_R01HeaderDto>>(url);
}

//입고 등록의 getWMS1020_R01WmsTransport와 비슷한 역할을 함
export const getWMS1031_R01TransportHeader = async (wmsOrderNo: string) => {
    const url = `${baseUrl}/transport/${wmsOrderNo}`;

    return await getData<ResponseDto<WMS1031_R01HeaderDto>>(url);
}

export const getWMS1031_R01DetailList = async (wmsOrderNo: string, warehouseCd: string) => {
	const url = `${baseUrl}/detail/${wmsOrderNo}/${warehouseCd}`;

	return await getData<ResponseDto<WMS1031_R01DetailDto[]>>(url);
}

export const getWMS1031_R01LotList = async (warehouseCd: string, itemCd: string, itemStatus: string) => {
	const url = `${baseUrl}/lot`;

	return await getData<ResponseDto<WMS1031_R01LotDto[]>>(url, { params: { 
			warehouseCd : warehouseCd || undefined,
			itemCd : itemCd || undefined,
			itemStatus : itemStatus || undefined
		} 
	});
}

export const postWMS1031_R01 = async (data: WMS1031_R01Dto) => {

	const url = `${baseUrl}`;

	return await postData<WMS1031_R01Dto, ResponseDto<WMS1031_R01Dto[]>>(url, data);
}

export const patchWMS1031_R01 = async (data: WMS1031_R01Dto) => {

	const url = `${baseUrl}`;

	return await patchData<WMS1031_R01Dto, ResponseDto<WMS1031_R01Dto[]>>(url, data);
}

export const deleteWMS1031_R01 = async (wmsOrderNo: string) => {

	const url = `${baseUrl}`;

	return await deleteData<ResponseDto<any>>(url, {
		params: {
			wmsOrderNo
		}
	});
}

export const downloadExcel_WMS1031_R01 = async (option: string, wmsOrderNo: string, warehouseCd: string, listLength: number = 0) => {
	const url = `${baseUrl}/excel/${option}`

	return await getData<ResponseDto<string>>(url, {
		params: {
			wmsOrderNo,
			warehouseCd
		}
	})
}
